module.exports = __webpack_public_path__ + "static/media/information_icon.b5df2d61.svg";